// extracted by mini-css-extract-plugin
export default {"tasks_search_wrapper":"Tasks_tasks_search_wrapper__2qF5y","search_input_field":"Tasks_search_input_field__x+qQe"};